module.exports = __webpack_public_path__ + "img/gift2.4a2da8d6.png";